import React, { PureComponent } from "react";
import { connect } from "react-redux";

import _ from "i18n";

import styles from "./ManageLayout.local.scss";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import Settings from "./Settings";
import Preview from "./Preview";
import PageViewer from "Reveal/PageViewer";

import { addNewBloc, setSelectedLayout, setCurrentNavPage } from "Actions";
import { saveBloc } from "Thunks";

class ManageLayout extends PureComponent {
  state = {
    unsaved: false
  };

  componentDidMount() {
    this.props.setCurrentNavPage("LAYOUT_PAGE");
  }
  saveLayoutSettings() {
    const { saveBloc, setSelectedLayout } = this.props;
    setSelectedLayout(0);
    saveBloc();
    this.setUnsaved(false);
  }
  setUnsaved = value => {
    this.setState(
      {
        unsaved: value
      },
      () => console.log(this.state.unsaved)
    );
  };
  render() {
    const { addNewBloc, saving } = this.props;
    return (
      <div className={styles.layout}>
        <div className={styles.header}>
          <NavLink to="/" className={styles.back}>
            <span className={styles.arrow} />
            {_("Home")}
          </NavLink>
          <h1>{_("Manage Layout")}</h1>
        </div>

        <div className={styles.body}>
          <div className={styles.head}>
            <div className={styles.titles}>
              <h2>{_("Configure layouts")}</h2>
              <p>{_("Ajouter et configurer les layouts")}</p>
            </div>
            <div className={styles.saveBtn}>
              <button
                className={styles.save}
                onClick={this.saveLayoutSettings.bind(this)}
              >
                {saving ? (
                  <i className={classnames(styles.saving, "icon-options")} />
                ) : (
                  _("Save")
                )}
              </button>
            </div>
          </div>

          <Settings
            saveBloc={this.saveLayoutSettings.bind(this)}
            setUnsaved={this.setUnsaved}
            unsaved={this.state.unsaved}
          />
          {/* <div className="cell small-12 medium-7"><Preview /></div> */}
        </div>
        <ul className={styles.bubbles}>
          <li
            onClick={() => {
              this.setUnsaved(true);
              addNewBloc();
            }}
          >
            <img src="/img/icons/plus-outline.svg" alt="" />
            {_("Add new bloc")}
          </li>
        </ul>
        <PageViewer />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  saving: state.hub.saving
});
const mapDispatchToProps = dispatch => ({
  addNewBloc: () => dispatch(addNewBloc()),
  saveBloc: () => dispatch(saveBloc()),
  setSelectedLayout: index => dispatch(setSelectedLayout(index)),
  setCurrentNavPage: page => dispatch(setCurrentNavPage(page))
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageLayout);



// WEBPACK FOOTER //
// ./src/components/Settings/ManageLayout/index.js